function storageFactory(storage) {
    let inMemoryStorage = {};

    function isSupported() {
        try {
            const key = '__some_random_key_you_are_not_going_to_use__';
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        } catch (e) {
            return false;
        }
    }

    function getItem(key) {
        const value = isSupported() ? storage.getItem(key) : inMemoryStorage[key];
        try {
            if (value === null) return undefined;
            return typeof value === 'string' ? JSON.parse(value) : value;
        } catch (err) {
            return value;
        }
    }

    function setItem(key, value) {
        const parsedValue = typeof value === 'object' ? JSON.stringify(value) : value;
        if (isSupported()) {
            storage.setItem(key, parsedValue);
        } else {
            inMemoryStorage[key] = parsedValue;
        }
    }

    function removeItem(key) {
        if (isSupported()) {
            storage.removeItem(key);
        } else {
            delete inMemoryStorage[key];
        }
    }

    function clear() {
        if (isSupported()) {
            storage.clear();
        } else {
            inMemoryStorage = {};
        }
    }

    function getKey(n) {
        if (isSupported()) {
            return storage.key(n);
        }
        return Object.keys(inMemoryStorage)[n] || null;
    }

    return {
        getItem,
        setItem,
        removeItem,
        clear,
        getKey,
        getJSON: getItem,
        saveJSON: setItem,
    };
}

export default storageFactory(
  typeof window === 'undefined' ? {} : window.localStorage
);
